<template>
  <div class="smtPackageOut">
    <div class="header-button-box"></div>
    <el-form
      :model="searchForm"
      ref="searchForm"
      label-width="80px"
      style="overflow: hidden"
      :inline="true"
    >
      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
          v-model="searchForm.startTime"
          align="right"
          type="datetime"
          placeholder="选择开始日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
          v-model="searchForm.endTime"
          align="right"
          type="datetime"
          placeholder="选择结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <el-form-item prop="commitStatus" label="提交状态">
        <el-radio-group v-model="searchForm.commitStatus">
          <el-radio
            label="已提交"
            @click.native.prevent="cancelSelect('已提交', 'commitStatus')"
          ></el-radio>
          <el-radio
            label="已作废"
            @click.native.prevent="cancelSelect('已作废', 'commitStatus')"
          ></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item prop="deliveryStatus" label="交运状态">
        <el-radio-group v-model="searchForm.deliveryStatus">
          <el-radio
            label="未交运"
            @click.native.prevent="cancelSelect('未交运', 'deliveryStatus')"
          ></el-radio>
          <el-radio
            label="已交运"
            @click.native.prevent="cancelSelect('已交运', 'deliveryStatus')"
          ></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item prop="searchStr" style="margin-left: 50px">
        <el-input
          v-model.trim="searchForm.searchStr"
          placeholder="请输入订单号/订单ID"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{ textAlign: 'center' }"
      v-loading="tableLoading"
      row-key="id"
    >
      <el-table-column
        prop="handoverContentCode"
        label="LP单号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="handoverOrderId"
        label="运单号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="weight"
        label="预估重量（kg）"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="quantity"
        label="申报件数"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="commitStatus"
        label="提交状态"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="deliveryStatus"
        label="交运状态"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        width="180"
        prop="createTime"
        label="创建时间"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="view(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tablePagination.page"
        :page-sizes="pageSizeList"
        :page-size="tablePagination.size"
        layout="total, sizes,prev, pager, next, jumper"
        :total="tablePagination.total"
      ></el-pagination>
    </div>

    <bigPackageManageDetail
      v-if="viewVisible"
      :visible="viewVisible"
      :currentForm="currentForm"
      @cancelVisible="
        viewVisible = false;
        currentForm = {};
      "
      @updateList="getList"
    ></bigPackageManageDetail>
  </div>
</template>
<script>
import tableMixins from "./tableMixins";
import { ajaxPost, Baseurl } from "@/api/api/api";
import bigPackageManageDetail from "./components/bigPackageManageDetail.vue";
export default {
  name: "smtPackageOut",
  mixins: [tableMixins],
  data() {
    return {
      searchForm: {
        startTime: "", //开始时间
        endTime: "", //结束时间
        commitStatus: null,
        deliveryStatus: null,
        searchStr: null, //字符串查询
        searchStrList: [],
      },
      viewVisible: false, //大包详情
      currentForm: {},
    };
  },
  mounted() {
    const d = new Date();
    const startTime =
      d.getFullYear() +
      "-" +
      (d.getMonth() + 1) +
      "-" +
      d.getDate() +
      " 00:00:00";
    const endTime =
      d.getFullYear() +
      "-" +
      (d.getMonth() + 1) +
      "-" +
      d.getDate() +
      " 23:59:59";
    this.searchForm.startTime = startTime;
    this.searchForm.endTime = endTime;
    this.getList();
  },
  methods: {
    cancelSelect(value, field) {
      if (value === this.searchForm[field]) {
        this.searchForm[field] = null;
      } else {
        this.searchForm[field] = value;
      }
    },
    handleSelectionChange() {},
    getList() {
      const sendData = {
        page: this.tablePagination.page,
        size: this.tablePagination.size,
        ...this.searchForm,
      };
      console.log(this.searchForm);
      const API = Baseurl + "aliexpressParcel/selectAliexpressHandovers";

      this.tableLoading = true;
      ajaxPost(API, sendData)
        .then((res) => {
          this.loadingTable = false;
          const { code, data } = res.data;
          if (code === 200) {
            const { list, total } = data;
            this.tableData = list;
            this.tablePagination.total = total;
          } else {
            this.$message.error(data);
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.getList();
    },
    search() {
      this.getList();
    },

    //查看详情
    view(record) {
      this.viewVisible = true;
      this.currentForm = record;
    },
  },
  components: {
    bigPackageManageDetail,
  },
};
</script>
<style lang="scss" scoped>
.smtPackageOut {
  color: red;

  .header-button-box {
    margin: 10px 0;
  }

  .pagination-container {
    width: 1660px;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;

    .el-pagination {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
